import styled from "styled-components";

export const ContainerFilaVirtualCasa = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: transparent;
`;

export const FilaVirtualCasaTitulo = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 12px;
  margin-top: 40px;
`;

export const FilaVirtualCasaIcono = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 52px;
  text-align: center;
`;
export const FilaVirtualCasaTxt = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 52px;
  text-align: center;
`;
export const FilaVirtualCasaConoceMasTxt = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 104px;
  text-align: center;
  .FilaVirtualCasaConoceMasTxt {
    text-decoration: underline;
    cursor: pointer;
  }
`;
export const FilaVirtualCasaBotones = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 52px;
  text-align: center;
`;
